// extracted by mini-css-extract-plugin
export default {"hideTooltip":"p--z","fadeIn":"q--z","delay":"r--z","recommendedSizeTooltip":"s--z"};